import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { IEDate, uGetDateFormat } from '@/modules/@appbase/util';
import {getAmpm, getDayText, getTimetext} from '@reserve/disp-helper';
import { mapGetters } from 'vuex';
import * as types from '@reserve/store/types'
import modalHelper from '@appbase/util/modal-helper';
import { openReserveCalendarItem } from '@reserve/popup-handler';
import * as dateutil from '@appbase/util/date-helper';
import GridView from '@appbase/components/GridView/GridView.vue'
import OccurrenceSelect from '@reserve/components/OccurrenceSelect.vue';


@Component({
    components: {
        GridView
    },

    computed: mapGetters({
        eventList: types.CALENDAR_ENTIRE_EVENT_LIST,
        dailyEventList: types.CALENDAR_DAILY_EVENT_LIST,
        currentDate: types.CALENDAR_DATE_CURRENT,
        viewMode: types.CALENDAR_VIEWMODE
    }) 
})
export default class ListView  extends Vue {
    eventList!: reserve.CalendarItem[];
    dailyEventList!: reserve.CalendarItem[];
    currentDate!: reserve.DateItem;
    reserveModel: gridView.ModelItem<reserve.CalendarItem>[] = [];
    reserveHeaders: gridView.Header[] = [];
    viewMode!: number;

    @Watch('eventList')
    @Watch('dailyEventList')
    onEventListChanged(newVal: reserve.CalendarItem[]) {        
        if (this.viewMode === 0) {
            this.reserveModel = this.filterTodayEvents(this.eventList);
        } else if (this.viewMode == 3) {
            this.reserveModel = this.filterTodayEvents(this.dailyEventList);
        } else {
            this.reserveModel = newVal;
        }
    }

    filterTodayEvents(events: reserve.CalendarItem[]) {
        return events.filter(e =>
            (e.id !== 'null' &&
                dateutil.uGetDateFormat('dd', IEDate(e.start)) ===
                dateutil.uGetDateFormat('dd', IEDate(this.currentDate.date))) ||
            (e.id !== 'null' &&
                dateutil.uGetDateFormat('dd', IEDate(e.start)) <=
                dateutil.uGetDateFormat('dd', IEDate(this.currentDate.date)) &&
                dateutil.uGetDateFormat('dd', IEDate(e.end)) >=
                dateutil.uGetDateFormat('dd', IEDate(this.currentDate.date)))
        );
    }

    created() {     
        this.reserveHeaders = [
            { displayName: this.$t('제목').toString(), rowKey: 'subject', align: 'left', slotName: 'reserveTitle' },
            { displayName: this.$t('예약자명').toString(), rowKey: 'organizer', align: 'left', slotName: 'reserveOrganizer', width: '160' },
            { displayName: this.$t('W_Schedule_Start').toString(), rowKey: 'start', align: 'left', width: '180', slotName: 'reserveStart' },
            { displayName: this.$t('W_Schedule_End').toString(), rowKey: 'end', align: 'left', width: '180', slotName: 'reserveEnd' },
            { displayName: this.$t('W_Schedule_Location').toString(), rowKey: 'location', align: 'left', width: '160' },
            { displayName: this.$t('파일첨부').toString(), rowKey: 'hasAttachments', align: 'left', width: '80', slotName: 'reserveAttachment' }
        ]      
        
        if(this.eventList != null) {
            this.onEventListChanged(this.eventList);
        }
    }

    getColorClass(event: reserve.CalendarItem) {
        var colorClass: any = {};
        colorClass[event.color] = true;
        return colorClass;
    }

    getTimeText(reserveTime: string) {
        var datetime = IEDate(reserveTime);
        return `${uGetDateFormat('yyyy-MM-dd', datetime)} (${getDayText(reserveTime)[0]}) ${getAmpm(reserveTime)} ${getTimetext(reserveTime)}`;
    }

    getTimeTextAllDay(reserveTime: string) {
        var datetime = IEDate(reserveTime);
        datetime.setDate(datetime.getDate() - 1);
        return `${uGetDateFormat('yyyy-MM-dd', datetime)} (${getDayText(datetime.toString())[0]}) ${getAmpm(datetime.toString())} ${uGetDateFormat('H:i', datetime)}`;
    }

    onReserveDblClick(event: gridView.ModelItem<reserve.CalendarItem>) {
        if (event.appointmentType === 'Occurrence') {
            modalHelper.show({ component: OccurrenceSelect, force: true, value: event });
        } else if (event.appointmentType === 'Exception') {
            openReserveCalendarItem(event, 'exception');
        } else {
            openReserveCalendarItem(event);
        }
    }
}